<!-- Dim overlay -->
<div
  class="archive-overlay"
  data-cy="warning-archive-overlay"
  (click)="handleOnDownloadClosed()"
></div>

<!-- Modal -->
<div class="archive-modal rounded-2" data-cy="warning-archive-modal">
  <!-- Header -->
  <div class="archive-header">
    <div class="header-title">
      <span class="title-icon rb-ic rb-ic-storage text-deactivated"></span>
      <span class="title-text" data-cy="warning-archive-title">Warning Archive</span>
    </div>
    <span
      class="header-close rb-ic rb-ic-close text-deactivated hover-effect"
      data-cy="warning-archive-close"
      (click)="handleOnDownloadClosed()"
    ></span>
  </div>

  <!-- Path bar / breadcrumb -->
  <div class="archive-pathbar">
    <span class="path-icon rb-ic rb-ic-database text-deactivated"></span>
    @for (segment of currentPath(); track segment; let i = $index; let last = $last) {
      <span class="path-separator">/</span>
      <span
        class="path-segment"
        [class.path-segment--current]="last"
        [class.path-segment--muted]="!last"
        (click)="!last && navigateToPathSegment(i)"
      >
        {{ segment }}
      </span>
    }
  </div>

  <!-- List header -->
  <div class="archive-list-header">
    <div class="col-spacer"></div>
    <span class="col-name text-deactivated">NAME</span>
    <span class="col-size text-deactivated">SIZE</span>
    <div class="col-action"></div>
  </div>

  <!-- Loading state -->
  @if (isLoadingBlobs()) {
    <div class="archive-loading">
      <div class="archive-spinner spinner-border spinner-border-sm" role="status"></div>
      <span class="loading-text text-deactivated">Loading...</span>
    </div>
  }

  <!-- Error state -->
  @if (error() && !isLoadingBlobs()) {
    <div class="archive-error">
      <span class="error-icon rb-ic rb-ic-alert-error text-dangerous"></span>
      <span class="error-text text-deactivated">{{ error() }}</span>
      <button class="retry-btn" (click)="loadDirectory()">Retry</button>
    </div>
  }

  <!-- Empty state -->
  @if (!isLoadingBlobs() && !error() && folders().length === 0 && blobs().length === 0) {
    <div class="archive-empty">
      <span class="empty-text text-deactivated">No items found</span>
    </div>
  }

  <!-- List body -->
  @if (!isLoadingBlobs() && !error() && (folders().length > 0 || blobs().length > 0)) {
    <div class="archive-list-body" data-cy="warning-archive-list-body">
      <!-- Back row -->
      @if (currentPath().length > 1) {
        <div class="archive-row archive-row--back" (click)="navigateUp()">
          <span class="row-icon rb-ic rb-ic-arrow-left text-deactivated"></span>
          <div class="row-spacer"></div>
          <span class="row-name text-deactivated">..</span>
        </div>
      }

      <!-- Folder rows -->
      @for (folder of folders(); track folder.name) {
        <div
          class="archive-row archive-row--folder"
          data-cy="warning-archive-folder-row"
          (click)="navigateToFolder(folder.name)"
        >
          <span class="row-icon rb-ic rb-ic-folder text-hover"></span>
          <div class="row-spacer"></div>
          <span class="row-name row-name--strong" data-cy="warning-archive-folder-name">{{
            folder.displayName
          }}</span>
          <span class="row-size row-size--muted">&mdash;</span>
          <div class="row-action"></div>
        </div>
      }

      <!-- File rows -->
      @for (blob of blobs(); track blob.name) {
        <div class="archive-row archive-row--file" data-cy="warning-archive-file-row">
          <span class="row-icon rb-ic rb-ic-document text-deactivated"></span>
          <div class="row-spacer"></div>
          <span class="row-name row-name--default" data-cy="warning-archive-file-name">{{
            blob.displayName
          }}</span>
          <span class="row-size text-deactivated">{{ formatFileSize(blob.contentLength) }}</span>
          <div class="row-action">
            <button
              class="dl-btn"
              data-cy="warning-archive-file-download"
              (click)="downloadFile(blob.name)"
            >
              <span class="dl-icon rb-ic rb-ic-download"></span>
              Download
            </button>
          </div>
        </div>
      }
    </div>
  }

  <!-- Bottom bar -->
  <div class="archive-bottom">
    <span class="status-text text-deactivated">
      {{ folders().length }} folder{{ folders().length !== 1 ? 's' : '' }},
      {{ blobs().length }} file{{ blobs().length !== 1 ? 's' : '' }}
    </span>
  </div>
</div>
